import React from 'react'
import { EmblaOptionsType } from 'embla-carousel'
import useEmblaCarousel from 'embla-carousel-react'
import Autoplay from 'embla-carousel-autoplay'
import ClassNames from 'embla-carousel-class-names'
import { Box } from '@chakra-ui/react'
import './styles.css'
import {
  NextButton,
  PrevButton,
  usePrevNextButtons,
} from '@/app/[locale]/_components/EmblaCarousel/ArrowButtons'

const OPTIONS: EmblaOptionsType = {
  loop: true,
  align: 'center',
}

export default function Desktop({ slides }: { slides: React.ReactNode[] }) {
  const [emblaRef, emblaAPI] = useEmblaCarousel(OPTIONS, [
    Autoplay({ delay: 10000 }),
    ClassNames(),
  ])

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaAPI)

  return (
    <Box
      mt={6}
      as='section'
      className='embla desktop'
      style={
        {
          '--slide-size': slides.length > 2 ? '84%' : '100%',
          '--slide-spacing': '40px',
        } as React.CSSProperties
      }
    >
      <Box className='embla__viewport' ref={emblaRef}>
        <div className='embla__container'>{slides}</div>
      </Box>
      {slides.length > 2 && (
        <div className='embla__buttons'>
          <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
          <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
        </div>
      )}
    </Box>
  )
}
